// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__Ky_Df","buttons":"SendReceipts_buttons__2tBu3","email":"SendReceipts_email__15mIN","bookApptTitle":"SendReceipts_bookApptTitle__1Qa4T"};